import Canvas from 'editor/components/Canvas';
import Cursor, { CursorTypes } from 'editor/components/Cursor';
import DrawTempRectInteraction from 'editor/components/interactions/DrawTempRectInteraction';
import UpdateTextInteraction from 'editor/components/interactions/UpdateTextInteraction';
import Markup from 'editor/components/Markup';
import Overlay from 'editor/components/Overlay';
import SheetEvents from 'editor/components/SheetEvents';
import ToolOverlay from 'editor/components/ToolOverlay';
import { Point, Rect } from 'editor/geometry';
import { createEditorTextarea } from 'editor/utils/text';
import noop from 'lodash/noop';
import { MouseDownArgs, MouseMoveArgs, MouseUpArgs } from './index';

function mouseDown({ hit, world }: MouseDownArgs): void {
  const toolOverlayEntity = world.locate([Overlay, ToolOverlay]);
  if (!toolOverlayEntity) return;

  const overlayComp = toolOverlayEntity.get(Overlay);
  const tempCanvasComp = new Canvas();
  tempCanvasComp.canvas = overlayComp.overlayCanvas;

  world
    .createEntity()
    .add(tempCanvasComp)
    .add(
      new DrawTempRectInteraction({
        originX: hit.x,
        originY: hit.y,
        currentX: hit.x,
        currentY: hit.y,
        stroke: `#FF0000`,
        strokeWidth: 1,
      })
    );

  world.grabAll(SheetEvents).forEach(({ component }) => {
    component.emit('drawtext:mousedown');
  });
}

function mouseMove({ world, hit }: MouseMoveArgs): void {
  // Should always be crosshair cursor for now.
  world.grabAll(Cursor).forEach(({ component }) => {
    component.cursor = CursorTypes.Crosshair;
  });

  const dtri = world.locate(DrawTempRectInteraction);

  if (dtri) {
    const interaction = dtri.get(DrawTempRectInteraction);

    interaction.currentX = hit.x;
    interaction.currentY = hit.y;
  }
}

function mouseUp({
  world,
  markupKit,
  carnDoc,
  sheetComp,
  domOverlay,
}: MouseUpArgs): void {
  const dtri = world.locate(DrawTempRectInteraction);

  if (dtri) {
    const interaction = dtri.get(DrawTempRectInteraction);
    const { MKMarkup } = markupKit;
    const { originX, originY, currentX, currentY } = interaction;

    if (originX !== currentX && originY !== currentY) {
      const p1 = new Point(originX, originY);
      const p2 = new Point(currentX, currentY);
      const box = Rect.fromPoints(p1, p2);

      const mkMarkup = MKMarkup.createFreeText();

      mkMarkup.setRect(box.left, box.bottom, box.right, box.top);

      const markupComp = new Markup();
      markupComp.mkMarkup = mkMarkup;
      markupComp.selected = true;
      markupComp.hidden = true;

      world
        .createEntity()
        .add(carnDoc)
        .add(sheetComp)
        .add(domOverlay)
        .add(markupComp)
        .add(
          new UpdateTextInteraction({
            box,
            element: createEditorTextarea(),
            elAdded: false,
            mode: 'create',
          })
        );

      world.grabAll(SheetEvents).forEach(({ component }) => {
        component.emit('drawtext:mouseup', { markupComp });
      });
    }

    dtri.destroy();
  }
}

function dblclick(): void {
  // unimplemented
}

export default {
  mouseDown,
  mouseMove,
  mouseUp,
  click: noop,
  dblclick,
};
